import { localStore } from 'utils';
const updateRecentlyProcessed = (key, value) => {
  const obj = JSON.parse(localStore.get(key)) || {};
  obj[value] = Date.now();
  localStore.put(key, JSON.stringify(obj));
};
export default updateRecentlyProcessed;
